import { RequestOfferRequest } from '@coldtec/cos-types';

/**
 *  Available store action for the request.
 */
export enum RequestAction {
    /** Used to fetch and (re)store the request of the forwarded guid. */
    FETCH = 'request:fetch',

    /** Used to sync the spaces added spaces (refs). */
    SYNC_SPACES = 'request:sync:spaces',

    /** Used to sync the selected products. */
    SYNC_PRODUCTS = 'request:sync:products',
}

/**
 *  Available store getter for the spaces.
 */
export enum RequestGetter {
    /** Used to get the valid state of the request. */
    VALID = 'request:valid',

    /** Used to get the full request state. */
    REQUEST = 'request:request',

    /** Used to get the count of the spaces that are added to the request. */
    COUNT_SPACES = 'request:count:spaces',

    /** Used to get the count of the systems that are selected for the request. */
    COUNT_SYSTEMS = 'request:count:systems',

    /** Used to get the count of products that are added to the request. */
    COUNT_PRODUCTS = 'request:count:products',

    /** Used to get the total price of the request. */
    PRICE_TOTAL = 'request:price:total',
}

/**
 *  Available store mutation for the request.
 */
export enum RequestMutation {
    /** Used to store the valid state of the request. */
    VALID = 'request:valid',

    /** Used to (re)store the data of a request that is retrieved from the API. */
    REQUEST = 'request:store:data',

    /** Used to store the guid of the request which was (re)stored from the API. */
    REQUEST_GUID = 'request:store:guid',

    /** Used to store the currently added spaces (refs) that are added to the request. */
    SPACES = 'request:spaces',

    /** Used to store the service products (guids) that are added to the request. */
    PRODUCTS_SERVICE = 'request:products:service',

    /** Used to store the additional products that are added to the request. */
    PRODUCTS_ADDITIONAL = 'request:products:additional',
}

/**
 *  Holding the store's request state.
 */
export interface RequestState {
    /** Holding the overall valid state of the request. */
    valid: boolean;

    /** Holding the data of the request. */
    data: RequestOfferRequest;

    /** Holding the guid of an already saved (and restored) request. */
    guid: string | null;
}
